import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatDate } from '@/lib/utils';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Pemberitahuan mode lihat-saja, menempel di atas setiap halaman dashboard.
 *
 * Langganan yang habis tidak mengunci lembaga — API tetap melayani semua
 * request baca — tetapi setiap tombol simpan akan ditolak. Tanpa pemberitahuan
 * di depan, orang baru tahu setelah mengetik satu formulir penuh, dan yang
 * terbaca adalah aplikasi yang rusak, bukan langganan yang perlu diperpanjang.
 */
export function ReadOnlyBanner() {
  const readOnly = useAuthStore((state) => state.user?.readOnly ?? false);
  const dataPurgeAt = useAuthStore((state) => state.user?.dataPurgeAt ?? null);

  if (!readOnly) {
    return null;
  }

  return (
    <div
      role="status"
      className="mb-4 flex flex-wrap items-center gap-3 rounded-[var(--radius-lg)] border border-[var(--color-warning)] bg-[var(--color-warning-subtle)] p-4 text-sm text-[var(--color-warning-on-subtle)]"
    >
      <Lock className="size-4 shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1">
        <span className="font-semibold">Masa langganan sudah berakhir — mode lihat-saja.</span>{' '}
        {dataPurgeAt ? (
          <>
            Data masih bisa dilihat, dicetak, dan diunduh, tetapi{' '}
            <span className="font-semibold">
              akan dihapus permanen pada {formatDate(dataPurgeAt)}
            </span>{' '}
            bila langganan tidak dilanjutkan.
          </>
        ) : (
          <>
            Semua data tetap aman dan bisa dilihat, dicetak, serta diunduh. Untuk menambah atau
            mengubah data, perpanjang langganan lebih dulu.
          </>
        )}
      </p>
      <Link to="/langganan" className="font-semibold underline underline-offset-2">
        Perpanjang langganan
      </Link>
    </div>
  );
}
